module.exports = __webpack_public_path__ + "static/P10-89d955f1ddee9a5332ab2709c97d9e6b.webp";